module.exports = __webpack_public_path__ + "img/16.6.CODm.28fb6c36.png";